import React from 'react';
import {connect} from 'react-redux';
import {loginFetchData} from './LoginAction';
import {LOGIN_SUCCESSFUL} from '../utils/constants';
import {colors} from '../styles/colors';
import {translate} from 'react-i18next';

import InfoSnack from '../utils/InfoSnack';
import MyButton from '../components/MyButton';
import './Login.css';
import TopLifeLogo from './toplife-logo-white.svg';

class LoginScreen extends React.Component {
	constructor() {
		super();

		this.state = {
			email:
				process.env.NODE_ENV === 'development'
					? 'tomic@dvica.golf'
					: '',
			password:
				process.env.NODE_ENV === 'development' ? 'pupuxatomi' : '',
		};
	}

	componentWillMount() {
		document.body.style.backgroundColor = colors.primaryColor;

        const {email} = this.props.match.params;
        const {accesshash} = this.props.match.params;

        if(email && accesshash) {
            this.props.fetchData(email, null, accesshash);
        }
	}

	componentWillUnmount() {
		document.body.style.backgroundColor = null;
	}

	componentDidUpdate(prevProps) {
		if (prevProps.login !== this.props.login && prevProps.isLoading) {
			if (this.props.login.msg !== LOGIN_SUCCESSFUL) {
				this.infoSnack.showSnack(this.props.t('login:login_failed'));
			}
		} else if (
			prevProps.loadingLoginFailed !== this.props.loadingLoginFailed &&
			prevProps.isLoading
		) {
			this.infoSnack.showSnack(this.props.t('common:cell_failed'));
		}
	}

	handleChange = (name) => (event) => {
		this.setState({
			[name]: event.target.value,
		});
	};

	render() {
		const {t} = this.props;

		return (
			<div className='loginWrapper sideGutters'>
				<InfoSnack onRef={(ref) => (this.infoSnack = ref)} />
				<div className='formContainer'>
					<img src={TopLifeLogo} style={{marginBottom: 30}} />
					<h1 className='bottomGutterLarge'>{t('common:login')}</h1>
					<div className='inputContainer bottomGutter'>
						<label htmlFor='email' className='inputLabel'>
							{t('login:placeHolderMail')}
						</label>
						<input
							id='email'
							className='formInput'
							value={this.state.email}
							onChange={this.handleChange('email')}
						/>
					</div>
					<div className='inputContainer bottomGutterLarge'>
						<label htmlFor='password' className='inputLabel'>
							{t('login:placeHolderPassword')}
						</label>
						<input
							className='formInput'
							id='password'
							type='password'
							value={this.state.password}
							onChange={this.handleChange('password')}
						/>
					</div>
					<div className='bottomGutterLarge'>
						<MyButton
							title={t('common:login')}
							style={{background: '#fff'}}
							size='large'
							color='primary'
							loading={this.props.isLoading}
							onPressButton={() => this.onLogin()}
						/>
					</div>
					<div className='loginLinksContainer'>
						<a
							className='bottomGutterLarge'
							href='https://toplife.zone/my-account/lost-password/'
							style={{color: 'inherit'}}
						>
							{t('common:forgotPassword')}
						</a>
						<a
							href='https://toplife.zone/training-anpassen/'
							style={{color: 'inherit'}}
						>
							{t('common:register')}
						</a>
					</div>

					<p className='recaptchaDisclaimer'>This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.</p>

				</div>
			</div>
		);
	}

	onLogin = () => {
		this.props.fetchData(this.state.email, this.state.password);
	};
}

const mapStateToProps = (state) => {
	return {
		login: state.login,
		loadingLoginFailed: state.loadingLoginFailed,
		isLoading: state.loginIsLoading,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetchData: (email, password, accesshash) =>
			dispatch(loginFetchData(email, password, accesshash)),
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(translate(['login', 'common'])(LoginScreen));



// WEBPACK FOOTER //
// ./src/login/LoginScreen.js